import React, { useState } from 'react';
import PropTypes from 'prop-types';
import RevertChangesWarning from './RevertChangesWarning/RevertChangesWarning';
import PendingPaymentsWarning from './PendingPaymentsWarning/PendingPaymentsWarning';
import Modal from 'components/ui/Modal';
import { FormattedMessage } from 'react-intl';
import { StyledColumn } from './AfterSalesWarning.styles';
import { CancelButton } from 'components/ui/Button';
import { Row } from 'components/shared/Layout';

import { REVERT_CHANGE } from 'store/mutations';
import { useManagedMutation } from 'utils/managedHooks';
import { hasPendingPayments } from 'utils/booking';
import { bookingShape } from 'constants/propTypes';
import { bookingStatus } from 'types/booking';

const AfterSalesWarning = ({ isInAfterSales, latestRevisionAgent, reference, booking }) => {
  const openWarnings = isInAfterSales || booking.status === bookingStatus.PENDING_CHANGES;
  const [isOpen, toggleOpen] = useState(openWarnings);
  const closeModal = () => toggleOpen(false);
  const { payments, currency } = booking;
  const pendingPayments = hasPendingPayments({ payments });

  const [revertChanges, { loading }] = useManagedMutation(REVERT_CHANGE, {
    variables: {
      bookingReference: reference
    },
    refetchQueries: ['booking'],
    onCompleted: closeModal
  });

  return (
    <Modal
      isOpen={isOpen}
      title={<FormattedMessage id="manageBooking.theBookingIsLockedInAftersales" />}
      subtitle={
        <FormattedMessage
          id="manageBooking.theBookingIsLockedInAftersales.details"
          values={{
            agentName: latestRevisionAgent
          }}
        />
      }
      onClose={closeModal}
    >
      <Row>
        {pendingPayments ? (
          <PendingPaymentsWarning currency={currency} reference={reference} />
        ) : (
          <RevertChangesWarning revertChanges={revertChanges} loading={loading} />
        )}
        <StyledColumn span={3}>
          <CancelButton data-cy="cancel" onClick={closeModal}>
            <FormattedMessage id="manageBooking.cancel" />
          </CancelButton>
        </StyledColumn>
      </Row>
    </Modal>
  );
};

AfterSalesWarning.propTypes = {
  isInAfterSales: PropTypes.bool,
  latestRevisionAgent: PropTypes.string,
  reference: PropTypes.string,
  booking: bookingShape
};

export default AfterSalesWarning;
